export default "__VITE_ASSET__yf6Rp_3T__"